/*
 * Mobile drawer submenus expand and collapse in place.
 *
 * Dawn's MenuDrawer slides a whole panel in from the right and traps focus inside
 * it, which needs a back button to get out. The listener below runs in the capture
 * phase, so it stops that click handler before it fires and lets the native
 * `<details>` element open and close on the spot. The drawer itself — opening,
 * closing, focus trap, escape key — is untouched.
 */
document.addEventListener(
  'click',
  (event) => {
    const summary = event.target.closest('.menu-drawer__navigation summary');
    if (!summary) return;

    event.stopPropagation();

    // The native toggle runs after this handler, so the new state is the opposite
    // of the current one.
    const isOpening = !summary.parentElement.hasAttribute('open');
    summary.setAttribute('aria-expanded', String(isOpening));
  },
  true
);
